import { render, staticRenderFns } from "./BulkOfferTransformer.vue?vue&type=template&id=96cc54ba&scoped=true"
import script from "./BulkOfferTransformer.vue?vue&type=script&lang=js"
export * from "./BulkOfferTransformer.vue?vue&type=script&lang=js"
import style0 from "./BulkOfferTransformer.vue?vue&type=style&index=0&id=96cc54ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cc54ba",
  null
  
)

export default component.exports